/** Canonical identity: `<blockKey>:<itemId>`. blockKey scopes the id to one row. */
export const buildIdentity = (blockKey, itemId) => `${blockKey}:${itemId}`;
/**
 * Pure. Drops candidates from blocked creators, then keeps the first occurrence
 * of each `blockKey:id` identity. Server order of retained items is preserved.
 * Returns the original array reference when nothing was removed.
 */
export default function postProcessResolvedDiscoveryRow(blockKey, items, blockedCreatorIds, { getCreatorId, getItemId }) {
    const seen = new Set();
    const result = [];
    for (const rowItem of items) {
        const creatorId = getCreatorId(rowItem);
        if (creatorId != null && blockedCreatorIds.has(creatorId))
            continue;
        const itemId = getItemId(rowItem);
        if (itemId === null) {
            result.push(rowItem);
            continue;
        }
        const identity = buildIdentity(blockKey, itemId);
        if (seen.has(identity)) {
            continue;
        }
        seen.add(identity);
        result.push(rowItem);
    }
    return result.length === items.length ? items : result;
}
